var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { rndstr } from "./rndstr";
import { veri2pkce } from "./veri2pkce";
import { getstg, setstg } from "./stg";
import { apihost } from "../utils";
const ENV = window.location.host === 'www.kommunal-rapport.no'
    ? 'prod'
    : 'stage';
const CLIENT_ID = ENV === 'prod'
    ? 'no.kommunebarometeret'
    : 'no.kommunebarometeret';
//: 'no.krap.demo'
const SITE_ALIAS = CLIENT_ID.substring(3);
const CONNECTID_BASEURL = ENV === 'prod'
    ? 'connectid.no/user'
    : 'connectid.no/user';
//: 'api-test.mediaconnect.no/login';
const AUTHORIZE_ENDPOINT = `https://${CONNECTID_BASEURL}/oauth/authorize`;
const TOKEN_ENDPOINT = `${apihost()}/oauth/token`;
const REDIRECT_URI = `https://${window.location.host}/kommunebarometeret`;
const SCOPE = "read";
let access_token = null;
export const get_access_token = () => {
    var _a;
    if (!access_token) {
        const stg = getstg();
        access_token = (_a = stg.access_token) !== null && _a !== void 0 ? _a : null;
    }
    return access_token;
};
export const set_access_token = (token) => { access_token = token; };
const clr_access_token = () => { access_token = null; };
const redirauth = (state, challenge) => {
    const url = new URL(AUTHORIZE_ENDPOINT);
    url.searchParams.set("scope", SCOPE);
    url.searchParams.set("state", state);
    url.searchParams.set("response_type", "code");
    url.searchParams.set("approval_prompt", "auto");
    url.searchParams.set("code_challenge", challenge);
    url.searchParams.set("code_challenge_method", "S256");
    url.searchParams.set("redirect_uri", REDIRECT_URI);
    url.searchParams.set("client_id", CLIENT_ID);
    window.location.assign(url.toString());
};
const start = () => __awaiter(void 0, void 0, void 0, function* () {
    const state = JSON.stringify({
        siteAlias: SITE_ALIAS,
        contentUrl: `https:\/\/${window.location.host}`,
        action: "update"
    });
    const verifier = rndstr(64);
    const challenge = yield veri2pkce(verifier);
    sessionStorage.setItem('oauth_state', state);
    sessionStorage.setItem('pkce_verifier', verifier);
    redirauth(state, challenge);
});
const get_token = () => __awaiter(void 0, void 0, void 0, function* () {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const returnedState = params.get("state");
    const error = params.get("error");
    const errorDesc = params.get("error_description");
    if (!code && !error) {
        return null;
    }
    else if (error) {
        const msg = `OAuth error: ${error}${errorDesc ? ` - ${errorDesc}` : ""}`;
        throw new Error(msg);
    }
    else if (!code || !returnedState) {
        const msg = "OAuth failed in returning code or state to callback";
        throw new Error(msg);
    }
    const expectedState = sessionStorage.getItem('oauth_state');
    const verifier = sessionStorage.getItem('pkce_verifier');
    sessionStorage.removeItem('oauth_state');
    sessionStorage.removeItem('pkce_verifier');
    if (!expectedState || expectedState !== returnedState) {
        throw new Error("Invalid state (CSRF / mismatched response)");
    }
    else if (!verifier) {
        throw new Error("Missing PKCE verifier (sessionStorage lost?)");
    }
    const body = new URLSearchParams();
    body.set("redirect_uri", REDIRECT_URI);
    body.set("code", code);
    body.set("code_verifier", verifier);
    const response = yield fetch(TOKEN_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
    });
    if (!response.ok) {
        const text = yield response.text().catch(() => "");
        throw new Error(`Token endpoint error (${response.status} ): ${text}`);
    }
    const userObj = (yield response.json());
    const sess = getstg();
    set_access_token(userObj.access.token);
    sess.user = userObj.user;
    sess.access_token = userObj.access.token;
    setstg(sess);
    const url = new URL(window.location.href);
    if (url.searchParams.has('code')) {
        url.searchParams.delete('code');
        url.searchParams.delete('state');
        url.searchParams.delete('session_state');
        url.searchParams.append('access_token', userObj.access.token);
        window.location.replace(url.toString());
    }
});
export const oauth = {
    start,
    get_token,
    get_access_token
};
